<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" (ngSubmit)="save()" [formGroup]="customerForm">
    <div class="ir-modal--title">
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ (customer ? 'common.edit' : 'common.new') | translate }} {{ 'customers.customer' | translate }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td class="margin">
              <h2>
                <span
                  ><strong>{{ 'plugins.customer-info.customer' | translate }} #<i>*</i></strong></span
                >
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <input name="crmId" class="ir-form-set" type="text" formControlName="clientNumber" [readonly]="!!customer" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span
                  ><strong>{{ 'plugins.customer-info.customer-name' | translate }}<i>*</i></strong></span
                >
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <input name="name" class="ir-form-set" type="text" formControlName="name" />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="customerForm.invalid"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right" type="submit" *ngIf="processing">
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
